export default "__VITE_ASSET__BMHoV2ek__"